import PERMISSION_KEYS from './permission-keys';

export const PERMISSION_DESCRIPTION_KEYS: Record<string, string> = {
    [PERMISSION_KEYS.approve]:
        'facilities.permissionTemplates.permissionDescriptions.Approve',
    [PERMISSION_KEYS.cptAnalytics]:
        'facilities.permissionTemplates.permissionDescriptions.CPT Analytics',
    [PERMISSION_KEYS.manageProtocols]:
        'facilities.permissionTemplates.permissionDescriptions.Manage Protocols',
    [PERMISSION_KEYS.managePolicies]:
        'facilities.permissionTemplates.permissionDescriptions.Manage Policies',
    [PERMISSION_KEYS.manageGroups]:
        'facilities.permissionTemplates.permissionDescriptions.Manage Folders',
    [PERMISSION_KEYS.manageNotes]:
        'facilities.permissionTemplates.permissionDescriptions.Manage Notes',
    [PERMISSION_KEYS.manageFiles]:
        'facilities.permissionTemplates.permissionDescriptions.Manage Files',
    [PERMISSION_KEYS.approvePolicy]:
        'facilities.permissionTemplates.permissionDescriptions.Approve Policy',
};

export const PERMISSION_TITLE_KEYS: Record<string, string> = {
    [PERMISSION_KEYS.approve]:
        'facilities.permissionTemplates.permissionTitles.Approve',
    [PERMISSION_KEYS.cptAnalytics]:
        'facilities.permissionTemplates.permissionTitles.CPT Analytics',
    [PERMISSION_KEYS.manageProtocols]:
        'facilities.permissionTemplates.permissionTitles.Manage Protocols',
    [PERMISSION_KEYS.managePolicies]:
        'facilities.permissionTemplates.permissionTitles.Manage Policies',
    [PERMISSION_KEYS.manageGroups]:
        'facilities.permissionTemplates.permissionTitles.Manage Folders',
    [PERMISSION_KEYS.manageNotes]:
        'facilities.permissionTemplates.permissionTitles.Manage Notes',
    [PERMISSION_KEYS.manageFiles]:
        'facilities.permissionTemplates.permissionTitles.Manage Files',
    [PERMISSION_KEYS.approvePolicy]:
        'facilities.permissionTemplates.permissionTitles.Approve Policy',
};

export const ROLE_PURPOSE_KEY_PREFIX =
    'facilities.permissionTemplates.rolePurposes';

// Display-name overrides for permission keys whose stored value no longer
// matches the product wording.
export const PERMISSION_DISPLAY_LABELS: Partial<Record<string, string>> = {
    [PERMISSION_KEYS.approve]: 'Approve Implants',
    [PERMISSION_KEYS.manageGroups]: 'Manage Folders',
};

export function getPermissionLabel(
    key: string,
    t?: (translationKey: string) => string
): string {
    const titleKey = PERMISSION_TITLE_KEYS[key];
    if (t && titleKey) return t(titleKey);
    return PERMISSION_DISPLAY_LABELS[key] ?? key;
}
